module.exports = __webpack_public_path__ + "img/label3.3d0b83b0.png";